<template>
    <v-container class="hn-goal-setting row border">
        <v-row class="v-patient-overview-hn-goal-setting">
            <v-col cols="12">
                <p>{{ $t('healthyNutrition.NutritionScoreExplanation') }}</p>
                <div class="mt-4 border">
                    <table>
                        <thead class="v-patient-overview-hn-goal-setting_table-head">
                            <tr>
                                <th class="text-left v-patient-overview-hn-goal-setting_table-h">
                                    {{ $ucfirst($t('myWeekMedicationDetail.name', { catalog: "app_mobile" })) }}
                                </th>
                                <th class="text-left v-patient-overview-hn-goal-setting_table-h">
                                    {{ $ucfirst($t('educationOverview.function.keyword.information', { catalog: "content" })) }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="item in goals"
                                :key="item.goal"
                                class="v-patient-overview-hn-goal-setting_table-row"
                            >
                                <td class="v-patient-overview-hn-goal-setting_table-d">{{ $t(item.goal, { catalog: 'content' }) }}</td>
                                <td class="v-patient-overview-hn-goal-setting_table-d">{{ $t(item.information, { catalog: 'content' }) }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: "PatientOverviewHNGoalSetting",
    data () {
       return {
        goals: [
            {
                goal: "healthyNutritionGoalsFoodGroups.wholegrains.goal",
                information: "healthyNutritionGoalsFoodGroups.wholegrains.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.potatoes.goal",
                information: "healthyNutritionGoalsFoodGroups.potatoes.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.fruit.goal",
                information: "healthyNutritionGoalsFoodGroups.fruit.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.vegetables.goal",
                information: "healthyNutritionGoalsFoodGroups.vegetables.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.legumes.goal",
                information: "healthyNutritionGoalsFoodGroups.legumes.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.fish.goal",
                information: "healthyNutritionGoalsFoodGroups.fish.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.redMeat.goal",
                information: "healthyNutritionGoalsFoodGroups.redMeat.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.poultry.goal",
                information: "healthyNutritionGoalsFoodGroups.poultry.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.fullFatDairy.goal",
                information: "healthyNutritionGoalsFoodGroups.fullFatDairy.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.healthyFats.goal",
                information: "healthyNutritionGoalsFoodGroups.healthyFats.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.alcoholicBeverages.goal",
                information: "healthyNutritionGoalsFoodGroups.alcoholicBeverages.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.addedSalt.goal",
                information: "healthyNutritionGoalsFoodGroups.addedSalt.information2"
            },
            {
                goal: "healthyNutritionGoalsFoodGroups.addedSugar.goal",
                information: "healthyNutritionGoalsFoodGroups.addedSugar.information2"
            },
        ]
       }
    }
}
</script>

<style>
.v-patient-overview-hn-goal-setting__infographic {
    max-width: 750px;
    width: 100%;

}

.v-patient-overview-hn-goal-setting_table-head {
    background-color: #d6dbe4;

}

.v-patient-overview-hn-goal-setting_table-h {
    padding: 16px;
}

.v-patient-overview-hn-goal-setting_table-h:nth-child(1) {
    border-top-left-radius: 16px;
}

.v-patient-overview-hn-goal-setting_table-h:last-child {
    border-top-right-radius: 16px;
}

.v-patient-overview-hn-goal-setting_table-d {
    padding: 16px;
    border-bottom-width: 1px;
    border-bottom-color: #d6dbe4;
    border-bottom-style: solid;
}
</style>